export default "__VITE_ASSET__a4752222__"